import React from 'react';
import { IIcon, useIconProps } from '../useIconProps';
import NoDataSvgIcon from './noData.svgrIcon.svg';
import NoDataSecondarySvgIcon from './noDataSecondary.svgrIcon.svg';

interface INoDataIconProps extends IIcon {
  type?: 'primary' | 'secondary';
}

export const NoDataIcon = React.forwardRef(({ type = 'primary', ...props }: INoDataIconProps, ref) => {
  const iconProps = useIconProps({
    ref,
    size: 20,
    ...props,
  });

  return type === 'primary' ? <NoDataSvgIcon {...iconProps} /> : <NoDataSecondarySvgIcon {...iconProps} />;
});
